import { TODAY, YESTERDAY, THIS_WEEK, LAST_WEEK, THIS_MONTH, LAST_MONTH, LAST_QUARTER, THIS_QUARTER, LAST_YEAR, THIS_YEAR } from 'foundations-components/transitional/components/Dates';
import I18n from 'I18n';
import { fromMoment } from 'foundations-components/transitional/utils/SimpleDate';
export const certificationStatuses = ['ACTIVE', 'EXPIRED', 'IN_PROGRESS'];
export const tableNames = {
  playlistsAll: 'playlistsAll',
  playlistsCompleted: 'playlistsCompleted',
  playlistsIncomplete: 'playlistsIncomplete',
  certificationsIndex: 'certificationsIndex',
  certificationsByTeamActive: 'certificationsByTeamActive',
  certificationsByTeamExpired: 'certificationsByTeamExpired',
  certificationsByTeamInProgress: 'certificationsByTeamInProgress',
  teamMembers: 'teamMembers',
  certificationProfileActive: 'certificationProfileActive',
  certificationProfileExpired: 'certificationProfileExpired',
  certificationProfileInProgress: 'certificationProfileInProgress',
  contentAll: 'contentAll',
  contentCompleted: 'contentCompleted',
  contentIncomplete: 'contentIncomplete'
};
export const filterNames = {
  search: 'search',
  certificationStatuses: 'certificationStatuses',
  categories: 'categories',
  tools: 'tools',
  teams: 'teams',
  users: 'users',
  playlists: 'playlists',
  dueDate: 'dueDate',
  completedDate: 'completedDate',
  assignedByMe: 'assignedByMe',
  isUserPinned: 'isUserPinned',
  contentIds: 'contentIds',
  contentTypes: 'contentTypes'
};
export const commonFilters = [filterNames.certificationStatuses, filterNames.categories, filterNames.tools, filterNames.teams, filterNames.users, filterNames.playlists, filterNames.dueDate, filterNames.completedDate, filterNames.assignedByMe, filterNames.search];
const customDatePresets = {
  TOMORROW: {
    presetId: 'TOMORROW',
    getText: () => I18n.text('learningCenter.myTeam.filters.datePresets.tomorrow'),
    getValue: () => ({
      startDate: fromMoment(I18n.moment.userTz().add(1, 'day')),
      endDate: fromMoment(I18n.moment.userTz().add(1, 'day'))
    })
  },
  THIS_WEEK: Object.assign({}, THIS_WEEK, {
    getValue: () => ({
      startDate: fromMoment(I18n.moment.userTz().startOf('week')),
      endDate: fromMoment(I18n.moment.userTz().endOf('week'))
    })
  }),
  THIS_MONTH: Object.assign({}, THIS_MONTH, {
    getValue: () => ({
      startDate: fromMoment(I18n.moment.userTz().startOf('month')),
      endDate: fromMoment(I18n.moment.userTz().endOf('month'))
    })
  }),
  NEXT_MONTH: {
    presetId: 'NEXT_MONTH',
    getText: () => I18n.text('learningCenter.myTeam.filters.datePresets.nextMonth'),
    getValue: () => ({
      startDate: fromMoment(I18n.moment.userTz().add(1, 'month').startOf('month')),
      endDate: fromMoment(I18n.moment.userTz().add(1, 'month').endOf('month'))
    })
  },
  THIS_QUARTER: Object.assign({}, THIS_QUARTER, {
    getValue: () => ({
      startDate: fromMoment(I18n.moment.userTz().startOf('quarter')),
      endDate: fromMoment(I18n.moment.userTz().endOf('quarter'))
    })
  }),
  THIS_YEAR: Object.assign({}, THIS_YEAR, {
    getValue: () => ({
      startDate: fromMoment(I18n.moment.userTz().startOf('year')),
      endDate: fromMoment(I18n.moment.userTz().endOf('year'))
    })
  }),
  LATER_THIS_YEAR: {
    presetId: 'LATER_THIS_YEAR',
    getText: () => I18n.text('learningCenter.myTeam.filters.datePresets.laterThisYear'),
    getValue: () => ({
      startDate: fromMoment(I18n.moment.userTz()),
      endDate: fromMoment(I18n.moment.userTz().endOf('year'))
    })
  },
  FUTURE: {
    presetId: 'FUTURE',
    getText: () => I18n.text('learningCenter.myTeam.filters.datePresets.future'),
    getValue: () => ({
      startDate: fromMoment(I18n.moment.userTz()),
      endDate: {
        year: 2100,
        month: 0,
        date: 1
      }
    })
  },
  PAST: {
    presetId: 'PAST',
    getText: () => I18n.text('learningCenter.myTeam.filters.datePresets.past'),
    getValue: () => ({
      startDate: {
        year: 1970,
        month: 0,
        date: 1
      },
      endDate: fromMoment(I18n.moment.userTz())
    })
  }
};
export const dueDateOptions = {
  TODAY,
  YESTERDAY,
  TOMORROW: customDatePresets.TOMORROW,
  THIS_WEEK: customDatePresets.THIS_WEEK,
  LAST_WEEK,
  THIS_MONTH: customDatePresets.THIS_MONTH,
  LAST_MONTH,
  NEXT_MONTH: customDatePresets.NEXT_MONTH,
  THIS_QUARTER: customDatePresets.THIS_QUARTER,
  LAST_QUARTER,
  THIS_YEAR: customDatePresets.THIS_YEAR,
  LATER_THIS_YEAR: customDatePresets.LATER_THIS_YEAR,
  LAST_YEAR,
  PAST: customDatePresets.PAST,
  FUTURE: customDatePresets.FUTURE
};
export const completedDateOptions = {
  TODAY,
  YESTERDAY,
  THIS_WEEK,
  LAST_WEEK,
  THIS_MONTH,
  LAST_MONTH,
  THIS_QUARTER,
  LAST_QUARTER,
  THIS_YEAR,
  LAST_YEAR
};
export const sortByOptions = {
  PLAYLIST_NAME: 'PLAYLIST_NAME',
  TEAM_MEMBER_NAME: 'TEAM_MEMBER_NAME',
  PROGRESS: 'PROGRESS',
  DUE_DATE: 'DUE_DATE',
  COMPLETED_DATE: 'COMPLETED_DATE',
  CERTIFICATION_NAME: 'CERTIFICATION_NAME',
  NAME: 'NAME',
  EXPIRATION: 'EXPIRATION',
  EXPIRED: 'EXPIRED',
  COMPLETED_AT: 'COMPLETED_AT',
  ACTIVE: 'ACTIVE',
  EXPIRING_SOON: 'EXPIRING_SOON',
  IN_PROGRESS: 'IN_PROGRESS',
  PLAYLIST_COMPLETED: 'PLAYLIST_COMPLETED',
  PLAYLIST_INCOMPLETE: 'PLAYLIST_INCOMPLETE',
  USER_NAME: 'USER_NAME',
  CONTENT_NAME: 'CONTENT_NAME'
};
export const tableFilters = {
  [tableNames.playlistsAll]: [filterNames.search, filterNames.teams, filterNames.users, filterNames.playlists, filterNames.dueDate, filterNames.completedDate, filterNames.assignedByMe],
  [tableNames.playlistsCompleted]: [filterNames.search, filterNames.teams, filterNames.users, filterNames.playlists, filterNames.dueDate, filterNames.completedDate, filterNames.assignedByMe],
  [tableNames.playlistsIncomplete]: [filterNames.search, filterNames.teams, filterNames.users, filterNames.playlists, filterNames.dueDate, filterNames.assignedByMe],
  [tableNames.contentAll]: [filterNames.search, filterNames.assignedByMe, filterNames.completedDate, filterNames.contentIds, filterNames.contentTypes, filterNames.dueDate, filterNames.teams, filterNames.users],
  [tableNames.contentCompleted]: [filterNames.search, filterNames.assignedByMe, filterNames.completedDate, filterNames.contentIds, filterNames.contentTypes, filterNames.dueDate, filterNames.teams, filterNames.users],
  [tableNames.contentIncomplete]: [filterNames.search, filterNames.assignedByMe, filterNames.contentIds, filterNames.contentTypes, filterNames.dueDate, filterNames.teams, filterNames.users],
  [tableNames.certificationsIndex]: [filterNames.search, filterNames.teams, filterNames.users, filterNames.certificationStatuses, filterNames.categories, filterNames.tools],
  [tableNames.certificationsByTeamActive]: [filterNames.search, filterNames.teams, filterNames.users, filterNames.categories, filterNames.tools],
  [tableNames.certificationsByTeamExpired]: [filterNames.search, filterNames.teams, filterNames.users, filterNames.categories, filterNames.tools],
  [tableNames.certificationsByTeamInProgress]: [filterNames.search, filterNames.teams, filterNames.users, filterNames.categories, filterNames.tools],
  [tableNames.teamMembers]: [filterNames.search, filterNames.teams, filterNames.users, filterNames.isUserPinned],
  [tableNames.certificationProfileActive]: [filterNames.search, filterNames.teams, filterNames.users],
  [tableNames.certificationProfileExpired]: [filterNames.search, filterNames.teams, filterNames.users],
  [tableNames.certificationProfileInProgress]: [filterNames.search, filterNames.teams, filterNames.users]
};
export const tableSortBy = {
  [tableNames.playlistsAll]: [sortByOptions.PLAYLIST_NAME, sortByOptions.TEAM_MEMBER_NAME, sortByOptions.PROGRESS, sortByOptions.DUE_DATE, sortByOptions.COMPLETED_DATE],
  [tableNames.playlistsCompleted]: [sortByOptions.PLAYLIST_NAME, sortByOptions.TEAM_MEMBER_NAME, sortByOptions.PROGRESS, sortByOptions.DUE_DATE, sortByOptions.COMPLETED_DATE],
  [tableNames.playlistsIncomplete]: [sortByOptions.PLAYLIST_NAME, sortByOptions.TEAM_MEMBER_NAME, sortByOptions.PROGRESS, sortByOptions.DUE_DATE],
  [tableNames.contentAll]: [sortByOptions.CONTENT_NAME, sortByOptions.TEAM_MEMBER_NAME, sortByOptions.PROGRESS, sortByOptions.DUE_DATE, sortByOptions.COMPLETED_DATE],
  [tableNames.contentCompleted]: [sortByOptions.CONTENT_NAME, sortByOptions.TEAM_MEMBER_NAME, sortByOptions.DUE_DATE, sortByOptions.COMPLETED_DATE],
  [tableNames.contentIncomplete]: [sortByOptions.CONTENT_NAME, sortByOptions.TEAM_MEMBER_NAME, sortByOptions.PROGRESS, sortByOptions.DUE_DATE],
  [tableNames.certificationsIndex]: [sortByOptions.CERTIFICATION_NAME, sortByOptions.TEAM_MEMBER_NAME, sortByOptions.ACTIVE, sortByOptions.EXPIRING_SOON, sortByOptions.EXPIRED, sortByOptions.IN_PROGRESS],
  [tableNames.certificationProfileActive]: [sortByOptions.USER_NAME, sortByOptions.COMPLETED_AT, sortByOptions.EXPIRATION],
  [tableNames.certificationProfileExpired]: [sortByOptions.USER_NAME, sortByOptions.COMPLETED_AT, sortByOptions.EXPIRATION],
  [tableNames.certificationProfileInProgress]: [sortByOptions.USER_NAME, sortByOptions.PROGRESS],
  [tableNames.certificationsByTeamActive]: [sortByOptions.CERTIFICATION_NAME, sortByOptions.NAME, sortByOptions.COMPLETED_AT, sortByOptions.EXPIRATION],
  [tableNames.certificationsByTeamExpired]: [sortByOptions.CERTIFICATION_NAME, sortByOptions.NAME, sortByOptions.COMPLETED_AT, sortByOptions.EXPIRATION],
  [tableNames.certificationsByTeamInProgress]: [sortByOptions.CERTIFICATION_NAME, sortByOptions.NAME, sortByOptions.PROGRESS],
  [tableNames.teamMembers]: [sortByOptions.NAME, sortByOptions.ACTIVE, sortByOptions.EXPIRING_SOON, sortByOptions.EXPIRED, sortByOptions.IN_PROGRESS, sortByOptions.PLAYLIST_COMPLETED, sortByOptions.PLAYLIST_INCOMPLETE]
};